"use client";

// import { testId } from "@/shared/test/tesId/testId";
import { cn } from "@/components/libs/cn";
import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

export function Toaster({ className, ...props }: ToasterProps) {
  return (
    <Sonner
      className={cn(
        "toaster group",
        "pointer-events-none fixed right-4 top-4 z-[100] flex flex-col gap-2",
        "w-fit min-w-[200px] max-w-[380px]",
        className,
      )}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast: cn(
            "pointer-events-auto w-full flex items-center space-x-4 overflow-hidden rounded-xl p-4",
            "shadow-lg transition-all duration-200 ease-in-out",
            "bg-white/10 backdrop-blur-md",
            "data-[type=success]:text-green-fg",
            "data-[type=error]:text-red-500",
            "data-[type=info]:text-blue-500",
            "data-[type=warning]:text-yellow-500",
            "animate-in slide-in-from-right duration-200",
          ),
          title: "text-[13px] font-medium",
          description: "text-[13px]",
          actionButton: cn(
            "inline-flex items-center justify-center rounded-md px-3 py-1.5 text-[13px] font-medium transition-colors",
            "bg-black/10 hover:bg-black/20",
          ),
          cancelButton: cn(
            "inline-flex items-center justify-center rounded-md px-3 py-1.5 text-[13px] font-medium transition-colors",
            "text-black/50 hover:bg-black/10",
          ),
          closeButton: cn(
            "absolute right-2 top-2 rounded-md p-1 opacity-0 transition-opacity",
            "text-black/50 hover:text-black/70",
            "group-hover:opacity-100",
          ),
        },
        duration: 4000,
      }}
      {...props}
    />
  );
}
